module.exports = __webpack_public_path__ + "static/media/logo.90489e38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 793
// module chunks = 0